// extracted by mini-css-extract-plugin
export default {"wrapper":"s1-z","play":"t1-z"};